import { POWER_CURVE } from '../types'

const thirtyDaysAgo = new Date()
thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30)
const today = new Date()

const initial = {
  selectedDateRange: { startDate: thirtyDaysAgo, endDate: today },
  selectedPlant: null,
}

const powerCurve = (state = initial, action) => {
  switch (action.type) {
    case POWER_CURVE.DATE:
      return { ...state, selectedDateRange: action.payload }
    case POWER_CURVE.PLANT:
      return { ...state, selectedPlant: action.payload }
    default:
      return state
  }
}

export default powerCurve
